import { Controller } from "stimulus";

export default class extends Controller {
  static values = { zoom: Number, center: Object }

  connect() {
    setTimeout(() => {
      this.initMap();
      this.element.style.opacity = 1;
    }, 500);
  }

  async initMap() {
    try {
      const map = new google.maps.Map(document.getElementById("map"), {
        center: this.centerValue || { lat: 20, lng: 0 },
        zoom: parseInt(this.zoomValue) || 1.1,
        mapId: "347cf5ed8a57ffd9",
        disableDefaultUI: true,
      });
      this.initMarkers(map);
    } catch (err) {
      console.error("There was an error creating the map:", err);
    }
  }

  initMarkers(map) {
    const pins = JSON.parse(this.element.dataset.pins)?.location;
    const iconUrl =
      "https://cdn.shopify.com/s/files/1/0578/3420/9434/files/map-pin.svg?v=1629964764";
    pins?.forEach((pin) => {
      let _pin;
      let locationName;
      if (pin.includes(":")) {
        locationName = pin.split(":")[0];
        _pin = pin.split(":")[1];
      } else {
        _pin = pin;
      }

      const latlng = _pin.split(",").map((val) => parseFloat(val));

      if (_pin)
        new google.maps.Marker({
          position: { lat: latlng[0], lng: latlng[1] },
          icon: iconUrl,
          map: map,
          title: locationName || "",
        });
    });
  }
}
